import {
  Actions,
  FETCH_BILLING_PERIODS_SUCCESS,
  FETCH_ORG_SUCCESS,
  GET_CURRENT_ORGANIZATION_USERS_SUCCEEDED,
  UPDATE_ORGANIZATION_SUCCESS,
} from './actions';
import { IOrganizationState } from './types';

const initialState: IOrganizationState = {
  currentOrganization: null,
  currentOrganizationUsers: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
  },
  billingPeriods: [],
};

const reducer = (
  state: IOrganizationState = initialState,
  action: Actions
): IOrganizationState => {
  switch (action.type) {
    case FETCH_ORG_SUCCESS:
    case UPDATE_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        currentOrganization: action.payload.organization,
      };
    }
    case GET_CURRENT_ORGANIZATION_USERS_SUCCEEDED: {
      return {
        ...state,
        currentOrganizationUsers: {
          items: action.payload.organizationUsers,
          loading: false,
          queriedAtLeastOnce: true,
        },
      };
    }
    case FETCH_BILLING_PERIODS_SUCCESS:
      return {
        ...state,
        billingPeriods: action.payload.billingPeriods,
      };
    default:
      return { ...state };
  }
};

export default reducer;
